import React from "react";

import ActiveUsersTimelineCard from "./ActiveUsersTimelineCard";
import SignupsByPlatformCard from "./SignupsByPlatformCard";
import SignupsTimelineCard from "./SignupsTimelineCard";
import TrialingTimelineCard from "./TrialingTimelineCard";

import type { JSX } from "react";

import type { DashboardPeriodProps } from "../dashboard.types";

function SignupsAndSubscriptionsSection({
  period,
}: DashboardPeriodProps): JSX.Element {
  return (
    <div className="grid gap-4 @3xl:grid-cols-2">
      <SignupsTimelineCard period={period} />
      <SignupsByPlatformCard period={period} />
      <ActiveUsersTimelineCard period={period} />
      <TrialingTimelineCard period={period} />
    </div>
  );
}

export default SignupsAndSubscriptionsSection;
